const VARIANTS = {
  BLACK: 'black',
  WHITE: 'white',
  DANGER: 'danger',
  WARNING: 'warning',
  SUCCESS: 'success',
  INFO: 'info',
  GRAY: 'gray',
} as const;

export type VariantType =
  | 'black'
  | 'white'
  | 'danger'
  | 'warning'
  | 'success'
  | 'info'
  | 'gray';

export default VARIANTS;
